export default __webpack_public_path__ + "static/media/a16.f39cd21d.webp";